<template>
	<el-drawer :title="title" :visible.sync="visible" @close='comStateClose' size="800px" :close-on-press-escape="false"
		id="comDrawer" :modal-append-to-body="false">
		<div class="drawerView">
			<div class="drawerViewB" v-if="navType == 3 ||navType == 2">
                  <el-input v-model="keyword" placeholder="关键字"></el-input>
				   <el-button type="primary" plain @click="getListPet">搜索</el-button>
				  
			</div>
			<div class="tabView" v-if="navType == 2">
				<div class="tabTitle"></div>
				<div v-for="(item,index) in classOptions" :key="index">
					<div :class="categoryId== item.value?'activeTab':'tabItem'" @click="handleTabClick(item)">
						{{item.title}}</div>
				</div>
			</div>
			<div class="drawerViewT">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="title" label="名称" key="1" v-if="navType == 1">
					</el-table-column>
                    <el-table-column prop="onlineName" label="名称" key="1" v-if="navType == 2">
					</el-table-column>
					<el-table-column prop="insideName" label="名称" key="2" v-if="navType == 3">
					</el-table-column>
					<el-table-column prop="name" label="名称" key="2" v-if="navType == 4">
					</el-table-column>
					<el-table-column prop="epromNo" label="芯片号" key="3" v-if="navType == 3">
					</el-table-column>
					<el-table-column prop="insideNo" label="脖圈号" key="4" v-if="navType == 3">
					</el-table-column>
					<el-table-column label="操作" width="100">
						<template slot-scope="scope">
							<el-button @click="handleSelectClick(scope.row)" type="text" size="small">选择</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="drawerViewB">
				<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	import page from "@/components/page.vue"
	export default {
		components: {
			page
		},
		props: {
			comState: { //显示状态
				default: false
			},
			navType: {
				default: 0
			}
		},
		watch: {
			// 监视状态发生改变
			comState() {
				this.visible = this.comState;
			},
		},
		data() {
			return {
				visible: true,
				title: '',
				keyword:"",
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
                categoryId:'',
				tableData: [], //表格数据
				classOptions:[],//分类
				tabItem:''
			}
		},
		mounted() {
			console.log(this.navType,"`1111111");
			if (this.navType == 1) {
				this.title = '选取文章'
			} else if (this.navType == 2) {
				this.title = '选取商品'
			} else if (this.navType == 3) {
				this.title = '选取活体'
			} else if (this.navType == 4) {
				this.title = '宠百科'
			}
			this.getListData()
		},
		methods: {
			//选择
			handleSelectClick(row) {
				if (this.navType == 1) {
					this.$emit("closeOn", {
						type: 'submit',
						data: {
							param_id: row.id,
							param_name: row.title
						}
					});
				} else if (this.navType == 2) {
					this.$emit("closeOn", {
						type: 'submit',
						data: {
							param_id: row._id,
							param_name: row.onlineName
						}
					});
				} else if (this.navType == 3) {
					this.$emit("closeOn", {
						type: 'submit',
						data: {
							param_id: row._id,
							param_name: row.insideName
						}
					});
				} else if (this.navType == 4) {
					this.$emit("closeOn", {
						type: 'submit',
						data: {
							param_id: row.id,
							param_name: row.name
						}
					});
				}

			},
			
			getListPet(){
				this.getListData();
			},
			changePage(num) {
				this.page.page = num;
				this.getListData();
			},
			//获取详情
			getListData() {
				let params = {}
				if (this.navType == 1) {
					params = {
						pageIndex: this.page.page,
						pageSize: this.page.pageSize,
						type: 1
					}
					console.log(params)
					this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Article/GetArticleList', params).then((res) => {
						if (res.code == 0) {
						
							this.tableData = res.data.list;
							this.page.total = res.data.count;
						}
					})
				} else if (this.navType == 2) {
					params = {
						pageIndex: this.page.page,
						pageSize: this.page.pageSize,
                        status: 1,
                        keyword:this.keyword,
                        categoryId:this.categoryId
					}

					this.$http.post(process.env.VUE_APP_Url_baseData + '/api/shop/online/product/list', params).then((
						res) => {
							if (res.code == 0) {
								console.log(res.data,"商品")
								this.tableData = res.data.data;
							
								this.page.total = res.data.count;
							}
							this.getClassData()
						})
				} else if (this.navType == 3) {
					params = {
						pageIndex: this.page.page,
						pageSize: this.page.pageSize,
						name:this.keyword,
						petStatus: '1,3'
					}

					this.$http.post(process.env.VUE_APP_Url_baseData + '/api/product/pet/list', params).then((res) => {
						if (res.code == 0) {
							console.log(res.data)
							this.tableData = res.data.data;
							this.page.total = res.data.count;
						}
					})
				} else if (this.navType == 4) {
					params = {
						pageIndex: this.page.page,
						pageSize: this.page.pageSize,
						appShowStatus: '1'
					}

					this.$http.post(process.env.VUE_APP_Url_baseData + '/api/pet/type/list', params).then((res) => {
						if (res.code == 0) {
							console.log(res.data)
							this.tableData = res.data.data;
							this.page.total = res.data.count;
						}
					})
				}
			},
			getClassData() {
			this.$http.get(process.env.VUE_APP_Url_baseData + '/api/online/product/category/list').then((res) => {
				if (res.code == 0) {
					this.classOptions = res.data
					this.classOptions.unshift(
						{value:'',title:'全部'}
						)
				}
			})
		},
		handleTabClick(item){
			if (this.classOptions.value === item.value) return;
			
				this.classOptions = item;
				this.page.page = 1;
				this.categoryId = item.value;
				this.getListData(item)
		},
			//向父组件发射关闭弹框
			comStateClose() {
				this.$emit("closeOn", {
					type: 'close'
				});
			},
		},
	}
</script>

<style scoped lang="scss">
.tabView {
		font-size: 16px;
		color: #2A2A2A;
		font-weight: bold;
		display: flex;
		width: 100%;
		border-bottom: solid 2px #F5F5F5;
		.tabTitle {
			width: 40px;
		}
		.tabItem {
			margin:0 4px;
			line-height: 40px;
			box-sizing: border-box;
		}

		.activeTab {
			margin:0 5px;
			line-height: 40px;
			box-sizing: border-box;
			border-bottom: solid 2px #536bca;
		}
	}
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;
		display: flex;
		flex-direction: column;

		.drawerViewT {
			flex: 1;
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;
			padding: 0 32px;
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				cursor: pointer;
				box-sizing: border-box;
				border: solid 1px #577BFF;
				color: #577BFF;
			}
		}
	}
</style>
